import config from '../config';
import Utils from './Utils';

export default {
  getDownloadUrl: ({ show, episode }) => {
    if (!episode) {
      return null;
    } // download links are for episodes only
    const baseDownload = [config.baseUrl, 'public'];
    const token = show?.accessToken;
    if (episode) {
      let episodeAudioUrl = episode?.audio?.url;
      let extension = episodeAudioUrl.slice(episodeAudioUrl.lastIndexOf('.'));
      baseDownload.push('streams', show?._id, 'episodes', episode?._id + extension);
    }

    return baseDownload.join('/') + Utils.getQueryString({ token });
  },
};
